import React, { useState } from 'react';
import './App.scss';
import Logo from './assets/logo.png'
import { post } from './api/request';

const App = () => {
  const [con, setCon] = useState("");
  const [list, setList] = useState();

  const getList = async () => {
    const { code, data } = await post("/micro/information/queryZyInfo", {
      no: con,
    });
    if (code === 200) {
      setList(data);
    }
  };

  const toClick = () => {
    getList();
  };

  return (
    <div className="app">
      <header className="header">
        <a href="http://www.zhongyaoxunzheng.com.cn/index.html">
          {" "}
          <img src={Logo} alt="" />{" "}
        </a>
      </header>
      <center>
        <div className="cen-header">
          <span>信息查询</span>
        </div>
        <div className="inp">
          <span className="certificate">证书编号</span>
          <input
            type="text"
            placeholder="请输入证书编号"
            onChange={(e) => {
              setCon(e.target.value);
            }}
          />
          <button className="btn" onClick={() => toClick()}>
            {" "}
            搜索{" "}
          </button>
        </div>
        <div className="cont">
          {list ? (
            <div className="con-result">
              <ul>
                <li key={list.no}>
                  <p>{list.no}</p>
                  <span>{list.name}</span>
                  <span>{list.title}</span>
                  <span>{list.post}</span>
                </li>
              </ul>
            </div>
          ) : (
            <div className="result">
              <p className="num"> 请核对您要查询的编号 </p>
            </div>
          )}
        </div>
      </center>
      <footer>
        <span>Copyright @ 2019-2022 东方熏道（北京）健康管理有限公司</span>
        <span>粤ICP备14000000号</span>
      </footer>
    </div>
  );
}

export default App;
